<template>
    <div>
        <div>
            <span class="cs-studentList-Phone" @click="onClick">{{phone}}</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.cs-studentList-Phone {
    color: #409EFF;
    cursor: pointer;
}
</style>

<script>
export default {
    props: {
        data: {},
    },
    data() {
        return {
            phone: '',
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            if (!!this.data) {
                this.phone = this.data.Phone;
            }
        },
        onClick(){
            this.$emit("customEvent", this.data);
        }
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/homeworkStudentPhoneCell.vue